module.exports = __webpack_public_path__ + "img/about-vmw-cover.cd81c03d.jpg";